import React, { createContext, useContext, useState } from "react";

const CompanySettingsContext = createContext();

export const CompanySettingsProvider = ({ children }) => {
  const [companySettings, setCompanySettings] = useState(null);

  return (
    <CompanySettingsContext.Provider
      value={{ companySettings, setCompanySettings }}
    >
      {children}
    </CompanySettingsContext.Provider>
  );
};

export const useCompanySettings = () => {
  return useContext(CompanySettingsContext);
};
